<template>
  <div class="container" @click='closeInfo'>
    <h5>{{title}}</h5>
    <div class="table">
      <div class="row thead">
        <div class="item">培训时间</div>
        <div class="item">课程内容</div>
        <div class="item">授课老师</div>
        <div class="item">教室</div>
        <div class="item">报名人数</div>
        <div class="item"></div>
      </div>
      <div class="row" v-for="item,index in list">
        <div class="item">{{item.start_time}}</div>
        <div class="item">
          {{item.content}} <span class="icon_detal" @click.stop.prevent="showInfo(index)" v-if="item.details">!</span>
          <div class="info" v-html="item.details" ref="info">

          </div>
        </div>
        <div class="item">{{item.teacher}}</div>
        <div class="item">{{item.room}}教室 </div>
        <div class="item">已报{{item.already_user}}人/ <span>{{item.user_limit}}人</span> </div>
        <div class="item">
          <div :class="item.already_user*1>=item.user_limit*1||item.flag==1?'btn btn-default':'btn btn-primary'" @click="linkTo(item)">
            {{item.flag==1?'已报名':item.already_user*1>=item.user_limit*1?'已满':'报名'}}
          </div>
        </div>
      </div>
      <page-component :total="totalPage" :current="currentPage" @getPage="catchPage"></page-component>
    </div>
    <div class="user_center" @click="$router.push('/account')">
      个人中心
    </div>
  </div>
</template>

<script>
import pageComponent from '../components/pagination.vue'
export default {
  inject: ['ajax'],
  data() {
    return {
      list: [],
      // list: [{ "id": "39", "start_time": "\u5468\u56db-14:00", "end_time": "2020-11-26 16:00", "sign_start_time": "2020-11-16 10:40", "sign_end_time": "2020-11-25 17:00", "s_id": "1", "content": "\u53e4\u7434\u66f2\u300a\u4ed9\u7fc1\u64cd\u300b\u57fa\u7840\u8bb2\u89e3", "teacher": "\u5f20\u5f64", "details": "", "room": "\u7535\u8bdd\u901a\u77e5", "user_limit": "15", "already_user": "3", "create_time": "0", "update_time": "1605497556", "sort": "0", "is_deleted": "0", "is_show": "1", "cl_id": "4", "flag": 0 }],
      title: '',
      totalPage: 10,
      currentPage: 0
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    let id = this.$route.query.id
    let page = this.$route.query.page
    this.currentPage = this.$route.query.page
    this.title = this.$route.query.title
    this.ajax(`/api/Shop/courseList?id=${id}&page=${page}`, 'get', '', res => {
      this.list = res.data.data
      this.totalPage = res.data.count
    })
  },
  watch: {

  },
  methods: {
    closeInfo() {
      this.$refs.info.map(item => {
        item.style.display = "none"
      })
    },
    showInfo(index) {
      this.closeInfo()
      this.$refs.info[index].style.display = "block"
    },
    linkTo(item) {
      if (item.already_user * 1 >= item.user_limit * 1 || item.flag == 1) {
        return
      } else {
        this.$router.push({
          path: '/notice',
          query: {
            id: item.id,
            target: 'course'
          }
        })
      }
    },
    catchPage(page) {
      this.currentPage = page
      if (page != this.$route.query.page) {
        window.location.href = `/signup?id=${this.$route.query.id}&page=${page}&title=${this.$route.query.title}`
      }
    }
  },
  components: {
    pageComponent
  },
};
</script>

<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.row > .item {
  flex: 1;
  text-align: center;
  position: relative;
}

.row > .item > span {
  color: #999;
}

.thead {
  background: #4ba6ff !important;
  color: #fff;
}

.row:nth-child(2n + 1) {
  background: #f5f5f5;
}

.icon_detal {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  border: 1px solid #bfbaba;
  color: #bfbaba !important;
  font-size: 12px;
  display: inline-block;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  margin-left: 5px;
  position: absolute;
  right: 0;
  top: 0;
}
.info {
  display: none;
  position: absolute;
  background: #fff;
  padding: 10px;
  border-radius: 7px;
  z-index: 9999;
  right: 0;
  top: 100%;
  box-shadow: 0 0px 10px #ececec;
  min-width: 150px;
}
@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .cont .item {
    width: 100%;
  }
  .container {
    padding: 0.05rem;
  }
  .table {
    font-size: 0.12rem;
    width: 100%;
    overflow-x: auto;
  }
  .row {
    width: 7.5rem;
  }
  .btn {
    width: 0.45rem;
  }
  .icon_detal {
    position: relative;
  }
  .info {
    right: -100%;
  }
}
</style>